import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';
import { Bubble } from './bubble';

const AziendaStoria = () => {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-azienda-storia-storia" style={{ display: 'contents' }}>
      <Element name="storia">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)}>
          <div className="container-fluid padding px-5 py-5">
            <div className="row snf-text-color-white ml-2 mb-2">
              <div className="col-auto ">
                <img
                  src="/images/logo-sistemi.svg"
                  width="56"
                  height="auto"
                  alt="Logo Sistemi Informativi"
                />
              </div>
              <div className="col-auto snf-font-32 snf-font-w6 mb-5 title ">
                {intl.formatMessage({
                  defaultMessage: 'La nostra storia'
                })}
              </div>
            </div>
            <div className="row ml-2 whiteBorder mb-4">
              <div className="col">
                <div className="row ">
                  <div className="col-auto">
                    <Bubble radius="10rem 10rem 0rem 10rem">1979</Bubble>
                  </div>
                  <div className="col snf-text-color-white pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Con soli dieci dipendenti, un imprenditore decide di fondare un’azienda che si occupi di <strong>Sviluppo Software e System Integration</strong> nei settori Public, Finance, Industry & Telco.\n Siamo agli albori di Sistemi Informativi.'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="row ">
                  <div className="col-auto">
                    <Bubble radius="10rem 10rem 0rem 10rem">1989</Bubble>
                  </div>
                  <div className="col snf-text-color-white pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'L’anno di svolta: <strong>IBM entra nel capitale azionario</strong> fino ad acquisirne la totalità nel 1998, mentre gli anni seguenti vedono il susseguirsi di ambiziosi traguardi raggiunti, come l’apertura di nuove filiali, l’incorporazione di società quali <strong>Selfin, Findatasystem, Albis e CCS</strong>, e programmi di formazione rivolti ai propri specialisti.'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row ml-2 mb-4">
              <div className="col">
                <div className="row ">
                  <div className="col snf-text-color-white pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'Vista la rapida espansione e il successo ottenuto, un importante istituto bancario romano acquisisce più del 50% del capitale societario ed è così che nel 1988 viene aperta la prima <strong>filiale a Milano.</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                  <div className="col-auto">
                    <Bubble radius="0rem 10rem 10rem 10rem">1987</Bubble>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="row ">
                  <div className="col snf-text-color-white pt-2">
                    {intl.formatMessage(
                      {
                        defaultMessage:
                          'in Sistemi Informativi, abbiamo raggiunto circa <strong>900 dipendenti</strong>, distribuiti su <strong>5 sedi</strong> nel centro-nord Italia fra Roma, Rieti, Perugia, Milano e Torino, con un fatturato di 88 milioni di euro raggiunto nel 2019.'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                  <div className="col-auto">
                    <Bubble radius="0rem 10rem 10rem 10rem">
                      {intl.formatMessage({
                        defaultMessage: 'Oggi'
                      })}
                    </Bubble>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </div>
  );
};

AziendaStoria.displayName = "L'Azienda Storia ";
export { AziendaStoria };
